import { NavigationGuardNext, Route } from 'vue-router';
import store from '@/store';

export const ProfilePage = (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
  store.dispatch('privacyTerms/getPrivacyTerms');
  next();
};
